<div class="callback-container">
  <div class="callback-card">
    <h1>Iniciando sesión…</h1>
    <p>Estamos validando tus datos de acceso.</p>

    @if (loading()) {
      <p class="callback-status">Procesando inicio de sesión…</p>
    }

    @if (authError()) {
      <p class="callback-error">{{ authError() }}</p>
    }
  </div>
</div>
